// import { poof, stopConfetti } from './confetti.js';
require('./newConfetti.js');

function isFriend(friendType) {
	const friendKey = `isFriend_2026_${friendType}`;
	return !!localStorage.getItem(friendKey);
}

function isFriendSaleActive(friendType) {
	// Assuming customData is a global object representing your data
	return !!customData[`isFriendSaleActive_${friendType}`];
}



function rememberFriend(friendType) {
	const friendKey = `isFriend_2026_${friendType}`;
	localStorage.setItem(friendKey, true);
}

function forgetFriend(friendType) {
	const friendKey = `isFriend_2026_${friendType}`;
	localStorage.removeItem(friendKey);
}

function isNewFriend(friendType) {
	return !isFriend(friendType) && isFriendPage( friendType);
}

export function canAccessFriendTickets(friendType) {
	if (!friendType || !isFriendSaleActive(friendType)) {
		return false;
	}
	return isFriendPage(friendType) || isFriend(friendType);
}

export function isFriendPage(friendType) {
	let friendPage = '/vriendenvancultura26-27';
	if ( friendType === 'klassiek' ) {
		friendPage = '/klassiek-vriendenvoorverkoop-26-27';
	}
	if (window.location.toString().indexOf(friendPage) > 0) {
		return true;
	}
	return false;
}

function showFriendTicketButtons(selector) {
	if (document.body.contains(document.querySelector(selector))) {
		document.querySelectorAll(selector).forEach(el => el.classList.remove('hide'));
	}
}

function hideRegularTicketButtons(selector) {
	if (document.body.contains(document.querySelector(selector))) {
		document.querySelectorAll(selector).forEach(el => el.classList.add('hide'));
	}
}

export function showTicketButtons(friendType) {
	const friendSelector = `.btn--friend-sale-${friendType}`;
	const regularSelector = '.btn--has-friend-link';

	hideRegularTicketButtons(regularSelector);
	showFriendTicketButtons(friendSelector);
}

function sayHi(friendType) {
	console.log('Hi, ' + friendType + ' friend!');
}

function newConfetti() {
	var count = 100;
	var defaults = {
		origin: { y: 0.7 }
	};

	// Check if device is mobile
	const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

	// For mobile devices, use a simpler confetti effect
	if (isMobile) {
		fire(0.1, {
			spread: 60,
			startVelocity: 30,
			particleCount: 50,
			disableForReducedMotion: true
		});
		return;
	}

	// Desktop version
	function fire(particleRatio, opts) {
		confetti({
			...defaults,
			...opts,
			particleCount: Math.floor(count * particleRatio),
		});
	}

	fire(0.25, {
		spread: 26,
		startVelocity: 55,
	});
	fire(0.2, {
		spread: 60,
	});
	fire(0.35, {
		spread: 100,
		decay: 0.91,
		scalar: 0.8,
	});
	fire(0.1, {
		spread: 120,
		startVelocity: 25,
		decay: 0.92,
		scalar: 1.2,
	});
	fire(0.1, {
		spread: 120,
		startVelocity: 45,
	});
}

function doFriendFirstTimeActions(friendType) {
	sayHi(friendType);
	rememberFriend(friendType);
	showTicketButtons(friendType);
}

function doFriendAlwaysActions(friendType) {
	if (isFriendPage(friendType)) {
		newConfetti();
		newConfetti();
		newConfetti();
	}
	showTicketButtons(friendType);
	sayHi(friendType);
}

function vriendenverkoop(friendType) {
	if (isFriendSaleActive(friendType)) {

		if (isNewFriend(friendType)) {
			doFriendFirstTimeActions(friendType);
		}
		if (isFriend(friendType)) {
			doFriendAlwaysActions(friendType);
		}
	}
}

// Example of using a constant for friend types
const friendTypes = ['theater', 'klassiek']; // todo read from localized data
friendTypes.forEach(friendType => {
	// console.log(friendType);
	vriendenverkoop(friendType);
});
